import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/icon/no-data.png'
import _imports_1 from '@/assets/image/common/empty.png'


const _withScopeId = n => (_pushScopeId("data-v-f099cf9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "no-data" }
const _hoisted_2 = {
  key: 0,
  src: _imports_0
}
const _hoisted_3 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_4 = { class: "text-message" }




export default /*#__PURE__*/_defineComponent({
  __name: 'MNoData2',
  props: {
  message: String,
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!props.message)
      ? (_openBlock(), _createElementBlock("img", _hoisted_2))
      : (_openBlock(), _createElementBlock("img", _hoisted_3)),
    _createElementVNode("p", _hoisted_4, _toDisplayString(props.message), 1)
  ]))
}
}

})